import { useState } from 'react';

import { useLocation, navigate } from '@xing-com/crate-core-router';
import { SearchBox } from '@xing-com/crate-jobs-domain-search-components-search-box';
import type { LocationSuggestion } from '@xing-com/crate-jobs-hooks';
import { ROUTES } from '@xing-com/crate-jobs-paths';

function getPropActionOrigin(pathname: string): string | null {
  if (pathname.includes(ROUTES.jobsCompanyDirectory)) {
    return 'company_directory';
  }

  return null;
}

export const DirectorySearchBox: React.FC = () => {
  const { pathname } = useLocation();
  const [keywords, setKeywords] = useState('');
  const [location, setLocation] = useState('');
  const [cityId, setCityId] = useState('');

  const onSelectLocation = (item: LocationSuggestion): void => {
    setLocation(item.name);
    setCityId(item.cityId);
  };

  const onSubmit = (): void => {
    const propTrackActionOrigin = getPropActionOrigin(pathname);
    const query = new URLSearchParams();

    if (keywords) {
      query.set('keywords', keywords);
    }
    if (location) {
      query.set('location', location);
    }
    if (cityId) {
      query.set('cityId', cityId);
    }
    if (propTrackActionOrigin) {
      query.set('sc_o_PropActionOrigin', propTrackActionOrigin ?? '');
    }
    query.set('sc_o', 'jobs_search_button');

    navigate(`${ROUTES.search}?${query.toString()}`);
  };

  return (
    <SearchBox
      keywordsInput={keywords}
      locationInput={location}
      onChangeKeywords={setKeywords}
      onSelectKeywords={setKeywords}
      onChangeLocation={setLocation}
      onSelectLocation={onSelectLocation}
      onSubmit={onSubmit}
    />
  );
};
